/**
 * Auth Api
 * Auth Xpo Api which handles all the api restful calls
 *
 * OpenAPI spec version: v3.0.1.0
 * Contact: ea@xpo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { UserApplicationAccess } from '../model/userApplicationAccess';
import { ValidationResult } from '../model/validationResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserAccessesService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * User - Access By SubjectId/ClientId
     * This is getting the UserApplicationAccess by subjectId and clientId                Sample request:                GET /users/subjects/{subjectId}/clients/{clientId}/accesses
     * @param subjectId The Subject Id.
     * @param clientId The Client Id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersSubjectsSubjectIdClientsClientIdAccessesGet(subjectId: string, clientId: string, observe?: 'body', reportProgress?: boolean): Observable<UserApplicationAccess>;
    public usersSubjectsSubjectIdClientsClientIdAccessesGet(subjectId: string, clientId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserApplicationAccess>>;
    public usersSubjectsSubjectIdClientsClientIdAccessesGet(subjectId: string, clientId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserApplicationAccess>>;
    public usersSubjectsSubjectIdClientsClientIdAccessesGet(subjectId: string, clientId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (subjectId === null || subjectId === undefined) {
            throw new Error('Required parameter subjectId was null or undefined when calling usersSubjectsSubjectIdClientsClientIdAccessesGet.');
        }
        if (clientId === null || clientId === undefined) {
            throw new Error('Required parameter clientId was null or undefined when calling usersSubjectsSubjectIdClientsClientIdAccessesGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UserApplicationAccess>(`${this.configuration.basePath}/users/subjects/${encodeURIComponent(String(subjectId))}/clients/${encodeURIComponent(String(clientId))}/accesses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * User - Access Update
     * This is updating the user access for a User                Sample request:                POST /users/{userId}/accesses/{appId}                 [\&quot;\&quot;,\&quot;\&quot;]
     * @param userId The User Id.
     * @param appId The Application Id.
     * @param requestBody The applicationRoleIds.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersUserIdAccessesAppIdPut(userId: string, appId: string, requestBody?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<UserApplicationAccess>;
    public usersUserIdAccessesAppIdPut(userId: string, appId: string, requestBody?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserApplicationAccess>>;
    public usersUserIdAccessesAppIdPut(userId: string, appId: string, requestBody?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserApplicationAccess>>;
    public usersUserIdAccessesAppIdPut(userId: string, appId: string, requestBody?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling usersUserIdAccessesAppIdPut.');
        }
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling usersUserIdAccessesAppIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<UserApplicationAccess>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/accesses/${encodeURIComponent(String(appId))}`,
            requestBody,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * User - Accesses By UserId
     * This is getting all the UserApplicationAccesses by userid                Sample request:                GET /users/{userId}/accesses
     * @param userId The User Id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public usersUserIdAccessesGet(userId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<UserApplicationAccess>>;
    public usersUserIdAccessesGet(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserApplicationAccess>>>;
    public usersUserIdAccessesGet(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserApplicationAccess>>>;
    public usersUserIdAccessesGet(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling usersUserIdAccessesGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<UserApplicationAccess>>(`${this.configuration.basePath}/users/${encodeURIComponent(String(userId))}/accesses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/apiModule/api/userAccesses.service.ts